const Card = ({ className = '', children, ...props }) => (
  <div className={`rounded-xl border bg-[#1f2a46] text-white shadow ${className}`} {...props}>
    {children}
  </div>
);

const CardContent = ({ className = '', children, ...props }) => (
  <div className={`p-6 pt-0 ${className}`} {...props}>
    {children}
  </div>
);

export { Card, CardContent };
